import type { ClaimStatusI } from 'declarations/interfaces/claimStatuses';

import { get } from './api';

export const getClaimStatusesApi: (
  roofTopId: string | undefined
) => Promise<ClaimStatusI[]> = async roofTopId => {
  const response = await get<ClaimStatusI[]>('/tickets/claim-statuses', { roofTopId });
  return response.data;
};
